<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center my-5">
      <div class="col-11 col-md-5 mx-auto">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="-50"
            animateClass="animated"
            :begin="false"
          >
          <h2 class="serif col-blue ">
            Floorplan
          </h2>
          <hr>
          </u-animate>
        </u-animate-container>
      </div>
    </div>
    <div class="row d-flex justify-content-center my-5">
      <div class="col-11 col-md-6 mx-auto">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="-50"
            animateClass="animated"
            :begin="false"
          >
          <img :src="floorplan" alt="Floorplan" class="w-100" />
          </u-animate>
        </u-animate-container>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'Floorplan',
  components: {

  },
  data() {
    return {
      floorplan: '',
    }
  },
  created() {
    this.floorplan = this.$store.getters.getFloorplan
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
